import VehicleListHeader from './container';

export default VehicleListHeader;
